import { createCustomEnum } from "./customEnum";

const TerminalSolutionOrigin = createCustomEnum({
	Application: {
		name: "application",
		value: 1,
		displayName: "Application",
	},
	Merchant: {
		name: "merchant",
		value: 2,
		displayName: "Merchant",
	},
});

export default TerminalSolutionOrigin;
